import { render, staticRenderFns } from "./workTip.vue?vue&type=template&id=77ac993c&scoped=true&"
import script from "./workTip.vue?vue&type=script&lang=ts&"
export * from "./workTip.vue?vue&type=script&lang=ts&"
import style0 from "./workTip.vue?vue&type=style&index=0&id=77ac993c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.9.8_m6jvttnwtqqy6l4pi5vsxiehsy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ac993c",
  null
  
)

export default component.exports